import { TabPanel } from "@mui/lab";
import type { InvestorChangeRequestState } from "@entrilia/shared/api/workflowTypes";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useTabSearchParams from "@entrilia/shared/hooks/useTabSearchParams";
import GeneralPageHeader from "../../common/GeneralPageHeader";
import PageTabs from "../../common/PageTabs";
import ChangeRequestsList from "./ChangeRequestsList";

interface ChangeRequestsTabPanelProps {
  value: string;
  stateFilter?: InvestorChangeRequestState;
}

const tabValues = ["Pending", "Completed", "Rejected", "All"] as const;

const ChangeRequestsTabPanel = ({ value, stateFilter }: ChangeRequestsTabPanelProps) => (
  <TabPanel value={value} sx={{ height: "100%", px: 3, py: 2.5 }}>
    <ChangeRequestsList stateFilter={stateFilter} />
  </TabPanel>
);

const ChangeRequestsPage = () => {
  usePageTitle("Requests");

  const { selectedTab, onTabChange } = useTabSearchParams(tabValues);

  return (
    <>
      <GeneralPageHeader title="Requests" hideBorderLine />
      <PageTabs
        tabs={tabValues}
        labels={["Pending", "Approved", "Rejected", "All"]}
        value={selectedTab}
        onChange={onTabChange}
      >
        <ChangeRequestsTabPanel value="Pending" stateFilter="Pending" />
        <ChangeRequestsTabPanel value="Completed" stateFilter="Completed" />
        <ChangeRequestsTabPanel value="Rejected" stateFilter="Rejected" />
        <ChangeRequestsTabPanel value="All" />
      </PageTabs>
    </>
  );
};

export default ChangeRequestsPage;
